var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "c-object-puff" }, [
    _c("div", { staticClass: "c-object-puff__media" }, [
      _vm.projectImage && _vm.projectImage.src
        ? _c("img", {
            attrs: {
              src: _vm.projectImage.src,
              alt: _vm.projectImage.alt || _vm.projectTitle,
              loading: "lazy",
            },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-object-puff__content" }, [
      _c("h3", { staticClass: "c-object-puff__title" }, [
        _vm._v(_vm._s(_vm.projectTitle)),
      ]),
      _vm._v(" "),
      _vm.projectDescription
        ? _c("div", { staticClass: "c-object-puff__text" }, [
            _vm._v("\n      " + _vm._s(_vm.projectDescription) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.projectCtaLink && _vm.projectCtaText
        ? _c(
            "a",
            {
              staticClass: "c-object-puff__button",
              attrs: { href: _vm.projectCtaLink },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.projectCtaText) + "\n      "),
              _c("i", {
                staticClass: "fa-regular fa-arrow-right",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }